import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { map, mergeMap, switchMap } from 'rxjs/operators';
import { Availability, Product, ProductListing } from '../../types/product.type';
import { AppSettings } from '../../PRE-LOAD/app-settings';
import { Observable, of } from 'rxjs';
import { buildUrl } from '../../../../urls';
import { AuthService } from '../../auth/auth.service';
import { UserSelectionsService } from '../user-selections/user-selections.service';

export { }

declare let window: dmpgDlWindow;

@Injectable({
    providedIn: 'root'
})
export class AnalyticsService {
    private form: analyticsForm;
    private testDrive: analyticsTestDrive;
    private model: analyticsModel;
    private _appSettings: AppSettings;
    private _userSelectionService: UserSelectionsService

    constructor(
        private appSettings: AppSettings,
        private userSelectionService: UserSelectionsService,

    ) {
        window.dmpgDl = window.dmpgDl || new dmpgDL();
        window.dmpgDl.events = [];

        this._appSettings = appSettings;
        this._userSelectionService = userSelectionService;
    }

    private UpdateDataLayer() {

        if (this.model) {
            window.dmpgDl.model = this.model;
        }


        if (this.form) {
            window.dmpgDl.form = this.form;
            delete window.dmpgDl.form.started;
        }

        if (this.testDrive) {
            window.dmpgDl.testDrive = this.testDrive;
        }

    }

    pushEvent(event: string, data?: any) {
        data = JSON.parse(JSON.stringify(data));

        let eventData = {
            ...data,
            event: event
        };
        delete eventData.events;

        if (eventData.model == undefined) {
            delete eventData.model;
        }

        if (eventData.testDrive == undefined) {
            delete eventData.testDrive;
        }

        if (window.dmpgDl.events != undefined) {
            window.dmpgDl.events.push(eventData);
        }
    }

    setModel() {
        let model = this._userSelectionService.get("product") as Product

        if (model != null) {
            this.model = {
                id: model.rangeCode != null ? model.rangeCode : '',
                name: model.name != null ? model.name : '',
                series: model.series != null ? model.series : '',
                manufacturer: this._appSettings.apiBrand.toUpperCase()
            };

            this.UpdateDataLayer();
        }
    }

    setRttdForm(step: string) {

        let hasPdiOverride = (this._appSettings.overridePdiImport != null && this._appSettings.overridePdiImport.length > 0)
        if (this.form == null) {
            this.form = {
                id: hasPdiOverride ? this.appSettings.overridePdiImport : environment.brand == "bmw" ? 'PDIBMWI2762TDA' : 'PDIMINII2761TDA',
                name: 'Realtime Booking Form',
                type: 'TDA',
                step: step,
                started: false
            };

            this.testDrive = {
                type: 'Realtime Test Drive'
            };

            this.UpdateDataLayer();
            this.pushEvent('form.load.auto.dataLayer.load', { form: this.form, testDrive: this.testDrive })

        } else {
            this.setFormStep(step);
        }
    }

    setEventForm(name: string, step: string) {
        this.form = {
            // id: this._appSettings.overridePdiImport ?? '',
            name: `Event Form - ${name}`,
            type: 'RFC',
            step: step
        };
        this.UpdateDataLayer();
        this.pushEvent('form.load.auto.dataLayer.load', { form: this.form })
    }

    setFormStep(step: string) {
        this.form.step = step;
        this.UpdateDataLayer();
        this.pushEvent('form.interact.manual.click.nextStep', { form: this.form, model: this.model, testDrive: this.testDrive });
    }

    formStarted() {
        let eventName = 'form.interact.manual.click.start'
        let formStartEvent = window.dmpgDl.events != null ? window.dmpgDl.events.filter(f => f.event == eventName) : [];

        if (formStartEvent != null && formStartEvent.length == 0) {
            this.form.started = true;
            this.pushEvent(eventName, { form: this.form, model: this.model, testDrive: this.testDrive });
        }
    }

    formCompleted() {
        this.pushEvent('form.interact.auto.success.formSuccess', { form: this.form, model: this.model, testDrive: this.testDrive });
    }

    formError(formFields: any) {
        this.form.formDetails = formFields;
        this.pushEvent('form.interact.auto.error.formError', { form: this.form });

    }


    setTestDrive(time: Date) {

        if (this.testDrive != null) {
            this.testDrive.time = time
        }
        this.UpdateDataLayer();
    }
}

interface analyticsScreen {
    environment: string;
    brand: string;
    primaryCategory: string;
    subCategory: string;
    name: string;
    url: string;
    querystring: string;
    hash: string;
    previousPageUrl: string;
    domain: string;
    pageType: string;
    retailer: {
        retailerName: string;
        retailerId: string;
    }

}

interface analyticsForm {
    id?: string;
    product?: string;
    name: string;
    type: string;
    error?: string;
    step: string;
    formDetails?: any;
    started?: boolean;
}

interface analyticsTestDrive {
    type: string;
    time?: Date;
}

interface analyticsModel {
    id: string;
    name: string;
    primaryCategory?: string;
    subCategory?: string;
    subCategory2?: string;
    manufacturer: string;
    series: string;
    bodyType?: string;
    trim?: string;
    fuelType?: string;
    transmission?: string;
    motorization?: string;
    pricesFrom?: number;
}

interface analyticsFinance {
    type: string;
    offerId: string;
    product: string;
    downPayment: number;
    mileage: number;
    monthlyPayments: number;
    term: number;
    initialRental: number;
    monthlyPaymentValue: number;
    totalAmountPayable: number;
    offerType: string;
    modelTreeRef: string;
    offerModelTreeRef: string;
}

interface dmpgDlWindow extends Window {
    dmpgDl: iDmpgDL;
}

interface iDmpgDL {
    screen?: analyticsScreen;
    model?: analyticsModel;
    finance?: analyticsFinance;
    form?: analyticsForm;
    testDrive?: analyticsTestDrive;
    events?: any[];
}

class dmpgDL implements iDmpgDL {
    screen: analyticsScreen;
    events: any[] = [];
}
